module.exports = __webpack_public_path__ + "static/media/AddFile.ba9a61b4.svg";